<div class="container">
    <dx-load-panel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoader" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false" [message]="messageLoader" height="10%" width="15%"></dx-load-panel>
    <div *ngIf="firtsPart" class="card mt-5">
        <div class="card-body text-center">
            <img src="./assets/global/images/check-logo.png" alt="" srcset="">
            <p>Usted ha Aprobado el Formulario. Recibirá un mensaje de texto <br>OTP para la validación de identidad al siguiente número {{pnum}}</p>
            <div>
                <button (click)="toSecondPart()" class="btn btn-primary">Ok</button>
            </div>
        </div>
    </div>

    <div *ngIf="SecondPart" class="card mt-5">
        <div class="card-body text-center">
            <p>Términos y condiciones</p>
            <p>Por favor, lea cuidadosamente los siguientes términos y condiciones. <br>Use la barra de desplazamiento para ver el resto de la información</p>
            <div class="pdf-container">
                <pdf-viewer [src]="pdfSource" [render-text]="true" style="display: block;height: 50vh;"></pdf-viewer>
            </div>
            <div class="form-check form-check-inline mt-3">
                <input class="form-check-input" type="checkbox" id="chckTerminosAdministradorAsignado" value="1">
                <label class="form-check-label text-info" for="chckTerminosAdministradorAsignado"><u>Acepto Términos y Condiciones de Uso del Portal Web</u></label>
            </div>
            <div class="mt-3">
                <button (click)="sendTokenNumberValidate()" class="btn btn-primary">Continuar</button>
            </div>
        </div>
    </div>

    <div *ngIf="thirdPart" class="card mt-5">
        <div class="card-body text-center">
            <p>Se ha enviado un SMS con el código OTP al telefono {{pnum}}</p>
            <div class="form-group row">
                <div class="col-lg-6 m-auto text-center">
                    <label for="otpNumber"> Ingrese su código en el siguiente recuadro </label>
                    <input class="form-control text-center" type="text" name="otpNumber" placeholder="Introduzca el código OTP" id="otpNumber" autocomplete="off">
                </div>
            </div>
            <p>Su código tiene una validez de 90 segundos</p>
            <div class="mt-3">
                <button (click)="validateCodeOtp()" class="btn btn-primary">Verificar</button>
            </div>
            <hr>
            <p>La recepción del SMS puede tardar unos minutos... Si no ha recivido el SMS en un</p>
            <p>periodo de 5 minutos. Haga clic para reenviar el mensaje.</p>
            <div class="mt-3">
                <button (click)="sendTokenNumberValidate()" class="btn btn-primary">Reenviar SMS</button>
            </div>
        </div>
    </div>
    <div *ngIf="fourPart" class="card mt-5">
        <div class="card-body text-center">
            <img src="./assets/global/images/Xadvertencia.PNG" alt="" srcset="">
            <h2>¡Advertencia!</h2>
            <p>La validación no fue exitosa.</p>
            <p>Por favor valida las siguientes preguntas</p>
            <div>
                <button (click)="generarPreguntas()" class="btn btn-primary">Ok</button>
            </div>
        </div>
    </div>
    <div *ngIf="LoserEndPart" class="card mt-5">
        <div class="card-body text-center">
            <img src="./assets/global/images/Xadvertencia.PNG" alt="" srcset="">
            <h2>¡Advertencia!</h2>
            <p>La validación no fue exitosa.</p>
            <p>Se habilitará el proceso de validación físico</p>
            <div>
                <button (click)="toLogin()" class="btn btn-primary">Ok</button>
            </div>
        </div>
    </div>
    <div *ngIf="endPart" class="card mt-5">
        <div class="card-body text-center">
            <img src="./assets/global/images/check-logo.png" alt="" srcset="">
            <h2>Éxito</h2>
            <p>Su validación ha sido verificada satisfactoriamente</p>
            <div>
                <button (click)="toLogin()" class="btn btn-primary">Ok</button>
            </div>
        </div>
    </div>

    <div class="card mt-5" *ngIf="questionPart">
        <div class="card-body">
            <form id="formCuestionario">
                <hr>
                <ng-container *ngFor="let item of listPreguntas;let i = index">
                    <div class="mt-3">
                        <div>
                            <p>{{i + 1}}. {{item.texto}}</p>
                        </div>
                        <div class="form-check" *ngFor="let resp of item.respuesta">
                            <input type="radio" class="form-check-input" name="{{item.orden}}" id="{{resp.id}}-{{i}}">
                            <label for="{{resp.id}}-{{i}}"> {{resp.texto}}</label>
                        </div>
                        <hr>
                    </div>
                </ng-container>
            </form>
            <div>
                <button (click)="validarRespuestas()" class="btn btn-primary pull-right">Ok</button>
            </div>
        </div>
    </div>
</div>